import { useEffect, useState } from "react";
import { getWalletClaimInfo } from "../models/project";
const useFetchEligible = (
  expectedChainId: number | undefined | null,
  campaign_address: string | undefined | null,
  wallet_address: string | undefined | null,
  claimInfoHash: string | undefined | null
) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>();
  const [data, setData] = useState<any>();
  useEffect(() => {
    const getWalletEligible = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await getWalletClaimInfo({
          chain_id: String(expectedChainId),
          campaign_address: campaign_address,
          wallet_address: wallet_address,
          claimInfoHash: claimInfoHash,
        });

        setData(res);
        setLoading(false);
      } catch (e) {
        console.log("error", e);
        setError(e);
        setLoading(false);
      }
    };
    if (
      campaign_address !== undefined &&
      claimInfoHash !== undefined &&
      wallet_address !== undefined
    ) {
      getWalletEligible();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaign_address, wallet_address, claimInfoHash]);
  return {
    loading,
    error,
    data,
  };
};

export default useFetchEligible;
